import { ArrowLeft, XIcon } from "lucide-react";
import React from "react";

const DepositHeader: React.FC<{
	title: string;
	onBack: () => void;
	onClose: () => void;
}> = ({ title, onBack, onClose }) => (
	<div className="relative flex justify-center w-full">
		<ArrowLeft
			className="absolute left-0 text-textDark -top-2"
			role="button"
			onClick={onBack}
		/>
		<XIcon
			className="absolute right-0 -top-2"
			role="button"
			onClick={onClose}
		/>
		<h1 className="mt-1 text-2xl font-bold text-center text-textDark">
			{title}
		</h1>
	</div>
);

export default DepositHeader;
